import React, { useState, useRef } from 'react';
import { IoCloseOutline } from "react-icons/io5";
import ContactUs from './contactus';

const DemoModal = ({ isOpen, onClose }) => {
    const modalRef = useRef(null);

    const handleBackdropClick = (e) => {
        if (modalRef.current && !modalRef.current.contains(e.target)) {
            onClose();
        }
    };

    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4 z-[100] transition-all duration-300 ease-out"
            onClick={handleBackdropClick}
        >
            <div
                ref={modalRef}
                className="relative w-full max-h-[95vh] max-w-[90%] md:max-w-[80%] lg:max-w-[70%] overflow-y-auto rounded-2xl bg-white shadow-xl transition-all duration-300 ease-out transform opacity-100 scale-100"
            >
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 z-30 p-2 hover:bg-gray-100 rounded-full transition-colors bg-white shadow-lg"
                    aria-label="Close modal"
                >
                    <IoCloseOutline className="text-2xl text-gray-600" />
                </button>

                <ContactUs modalOpen={() => {}} onClose={onClose} />
            </div>
        </div>
    );
};

export default DemoModal;













